import { CgExternal } from 'react-icons/cg';

interface ExternalLinkProps {
  linkText: string;
  url: string;
  showIcon?: boolean;
}

export default function ExternalLink({ linkText, url, showIcon = true }: ExternalLinkProps) {
  return (
    <a href={url} target="_blank" rel="noreferrer">
      {linkText}
      {showIcon && <CgExternal size={'1rem'} />}
    </a>
  );
}
